/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StockTransferService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/StockTransfer",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  getProductBatches(itemCode, lineNo, stockTransferCode) {
    const requestScreenData = {
      url: "api/StockTransferProductBatch",
      filter: `ItemCode eq '${itemCode}' and StockTransferLineNo eq ${lineNo} and StockTransferCode eq ${stockTransferCode}`,
    };

    return ApiService.oDataGet(requestScreenData);
  },

  async save(payload, stockTransferCode) {
    // eslint-disable-next-line no-debugger
    // debugger;
    const url = `api/Save_StockTransfer`;

    if (stockTransferCode) {
      return await ApiService.put(url, stockTransferCode, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getStockTransferDetailsByCode(code, params) {
    let requestScreenData = {
      url: "api/StockTransferDetail",
      filter: `StockTransferCode eq ${code}`,
    };

    if (params) {
      requestScreenData = { ...requestScreenData, ...params };
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async cancel(code){
    const url =  "api/StockTransfer/Cancel";
    const payload = {
      Code: code,
      DateChanged: new Date().toISOString().replace("Z", ""),
    }
    return await ApiService.post(url, payload)
  }
};

export { StockTransferService };
